import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import QuoteForm from "../Components/QuoteForm";
import AntiqueSection from "../Components/AntiqueSection";
import { url, header } from "../Constent/Constant";

function PianoAndAntique() {
  const [PianoData, setPianoData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if (LoggedIn !== 'true') {
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Piano And Antique"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setPianoData(data.doc)
      })
  }

  const OnFormFill = (ObjectData) => {
    if (ObjectData !== null) {
      fetch(`${url}/page/getfreeestimation`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            firstname: ObjectData.fName,
            lastname: ObjectData.lName,
            email: ObjectData.email,
            phone: ObjectData.phone,
            address: ObjectData.address
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            message.success('Thank You')
          }
        })
    } else {
      console.error('Not fill Correctly')
    }
  }


  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }

  return (
    <Layout>
      {PianoData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: PianoData.section1image1._id,
          headingId: PianoData.section1heading1._id
        }}
        Image={PianoData.section1image1.image} />}

      {PianoData && <AntiqueSection
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        SectionData={PianoData} />}

      <div className='Piano-Container'>
        <div className='Info'>
          <h2> {PianoData ? PianoData.section2heading1.content : 'No text'}
            <i onClick={() => ShowTextModal(PianoData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
          </h2>
          <div className='Piano-list'>
            <p> {PianoData ? PianoData.section2paragraph1.content : 'No text'}
              <i onClick={() => ShowTextModal(PianoData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
            </p>
          </div>
        </div>
        <div className='Form'>
          <QuoteForm OnSubmit={OnFormFill} OriginalAddress='Original Address' />
        </div>
      </div>


      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default PianoAndAntique;
